import React, {useEffect, useState} from "react";
import classNames from "classnames";

type SearchNumberFieldProps = {
    placeholder?: string;
    disabled?: boolean;
    onChange: (value?: string | number) => void
    timeDelay?: number;
    minimumInput?: number;
    preventDefaultEvent?: boolean;
    additionalClasses?: string;
    initialValue?: string | number
    minVal?: number;
    maxVal?: number;
}
export const SearchNumberField = ({
                                      initialValue,
                                      onChange,
                                      timeDelay = 500,
                                      minVal,
                                      maxVal,
                                      placeholder,
                                      disabled,
                                      additionalClasses,
                                      ...props
                                  }: SearchNumberFieldProps) => {
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value)
        }, timeDelay)
        return () => clearTimeout(timeout)
    }, [value])

    return (
        <div className={classNames('d-flex flex-grow', additionalClasses)}>
            <input
                {...props}
                className="form-control"
                type="number"
                min={minVal}
                max={maxVal}
                value={value ?? ""}
                placeholder={`${placeholder}`}
                disabled={disabled}
                onChange={(event) => setValue(event.target.value)}
            />
        </div>
    )
}
